/*
Carousel Prev
*/

class CarouselPrev extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.querySelector("button")) {
      console.warn("You need to have a child button to go to previous!");
    }
    this.addEventListener("click", (e) => {
      const carousel = e.target.closest("site-carousel");

      if (carousel) {
        carousel.previous();
      } else {
        console.error("<carousel-prev> needs to be a child of <site-carousel>");
      }
    });
  }
}

customElements.define("carousel-prev", CarouselPrev);

/*
Carousel Next
*/

class CarouselNext extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.querySelector("button")) {
      console.warn("You need to have a child button to go to next!");
    }

    this.addEventListener("click", (e) => {
      const carousel = e.target.closest("site-carousel");
      if (carousel) {
        carousel.next();
      } else {
        console.error("<carousel-next> needs to be a child of <site-carousel>");
      }
    });
  }
}

customElements.define("carousel-next", CarouselNext);

/*
Carousel Pager
*/

class CarouselPager extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const pagerButtons = Array.from(this.querySelectorAll("button"));

    if (!pagerButtons.length > 1) {
      console.warn("No need for a pager with only one item!");
    } else {
      pagerButtons[0].classList.add("active");
    }

    pagerButtons.forEach((pager, i) => {
      pager.addEventListener("click", (e) => {
        const carousel = e.target.closest("site-carousel");

        if (carousel) {
          carousel.slideTo(i);
        } else {
          console.error(
            "<carousel-pager> needs to be a child of <site-carousel>"
          );
        }
      });
    });
  }
}

customElements.define("carousel-pager", CarouselPager);

/*
 * Site Carousel
 */

class SiteCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const rawConfig = this.dataset.config
      ? JSON.parse(this.dataset.config)
      : { slidesPerView: 1, spaceBetween: 20, loop: true };

    const carouselId = this.dataset.id;
    const swiperEl = this.querySelector(".swiper");

    const hasNavState = this.hasAttribute("data-nav-state");

    this.swiper = new Swiper(swiperEl, {
      ...rawConfig,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        bulletClass: "carousel-bullet",
        bulletActiveClass: "active",
        clickable: true,
      },
      on: {
        slideChange: () => {
          this.updateActiveThumb();
          if (hasNavState) this.updateNavState();
        },
      },
    });

    this.bindThumbnailClicks();
    this.updateActiveThumb();
    if (hasNavState) {
      this.bindExternalNav();
      this.updateNavState();
    }

    this.classList.remove("opacity-0");
  }

  bindExternalNav() {
    const wrapper = this.closest("[data-carousel-wrapper]");
    if (!wrapper) return;
    wrapper.querySelectorAll('[data-dir="prev"]').forEach(btn => btn.addEventListener("click", () => this.previous()));
    wrapper.querySelectorAll('[data-dir="next"]').forEach(btn => btn.addEventListener("click", () => this.next()));
  }

  bindThumbnailClicks() {
    const thumbs = this.querySelectorAll(".gallery-thumb");

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener("click", () => {
        if (this.swiper) {
          this.swiper.slideToLoop
            ? this.swiper.slideToLoop(index)
            : this.swiper.slideTo(index);
        }
      });
    });
  }

  updateActiveThumb() {
    const thumbs = this.querySelectorAll(".gallery-thumb");
    if (!thumbs.length || !this.swiper) return;

    const activeIndex = this.swiper.realIndex ?? this.swiper.activeIndex;

    thumbs.forEach((thumb, index) => {
      thumb.classList.toggle("active", index === activeIndex);
    });
  }

  previous() {
    if (this.swiper) this.swiper.slidePrev();
  }

  next() {
    if (this.swiper) this.swiper.slideNext();
  }

  slideTo(i) {
    if (this.swiper) {
      this.swiper.slideTo(i);
    }
  }

  updateNavState() {
    if (!this.swiper) return;
    const scope = this.closest("[data-carousel-wrapper]") || this;
    let prevBtns = scope.querySelectorAll('[data-dir="prev"]');
    let nextBtns = scope.querySelectorAll('[data-dir="next"]');
    if (!prevBtns.length) { const fb = scope.querySelector("carousel-prev .carousel-nav-btn"); if (fb) prevBtns = [fb]; }
    if (!nextBtns.length) { const fb = scope.querySelector("carousel-next .carousel-nav-btn"); if (fb) nextBtns = [fb]; }
    const fadeEdge = this.querySelector(".carousel-fade-edge");
    prevBtns.forEach(btn => btn.style.opacity = this.swiper.isBeginning ? "0.5" : "1");
    nextBtns.forEach(btn => btn.style.opacity = this.swiper.isEnd ? "0.5" : "1");
    if (fadeEdge) fadeEdge.style.opacity = this.swiper.isEnd ? "0" : "1";
  }
}

if (!customElements.get("site-carousel")) {
  customElements.define("site-carousel", SiteCarousel);
}

/*
Cart Toggle
*/

class CartToggle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.querySelector("button")) {
      console.warn("Cart toggle component should have a button as a child!");
    }

    this.addEventListener("click", (e) => {
      const cart = document.querySelector("site-cart");
      if (cart) {
        cart.toggleCart();
      }
    });
  }
}

customElements.define("cart-toggle", CartToggle);

/*
Cart Add
*/

class CartAdd extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelector("form").addEventListener("submit", async (e) => {
      e.preventDefault();

      const trialCampaignId = parseInt(this.dataset.trialCampaignId, 10);
      if (trialCampaignId) {
        const mainProduct = this.closest("main-product");
        const trialRadio = mainProduct?.querySelector('[data-purchase-type="trial"]:checked');
        if (trialRadio) {
          window.alia = window.alia || [];
          window.alia.push({ type: "open", campaignID: trialCampaignId, ignoreTargeting: true });
          return;
        }
      }

      const $id = e.target.querySelector('[name="id"]');
      const $qty = e.target.querySelector('[name="quantity"]');
      const $sellingPlan = e.target.querySelector('[name="selling_plan"]');
      const qty = $qty ? $qty.value : 1;
      const sellingPlan =
        $sellingPlan && !!$sellingPlan.value ? $sellingPlan.value : null;

      const action = this.dataset.action || "cart";

      const atcButton = this.querySelector('button[type="submit"]');
      const atcText = atcButton.innerHTML;

      atcButton.setAttribute("disabled", true);
      const loadingText = this.dataset.loadingText || "Adding to Cart...";
      atcButton.innerHTML = loadingText;

      if ($id) {
        const cart = document.querySelector("site-cart");
        const openCart = action === "cart";

        if (cart) {
          if (openCart) {
            atcButton.innerHTML = atcText;
            atcButton.removeAttribute("disabled");
          }
          await cart.addVariantToCart($id.value, qty, sellingPlan, openCart);
        }

        if (action === "checkout") {
          window.location.href = "/checkout";
        }
      }
    });
  }
}

customElements.define("cart-add", CartAdd);

/*
Update Quantity
*/

class UpdateQuantity extends HTMLElement {
  constructor() {
    super();
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  connectedCallback() {
    this.addEventListener(
      "click",
      this.debounce(async (e) => {
        const cart = document.querySelector("site-cart");
        const idx = this.dataset.index;
        const ctx = this.dataset.ctx;
        const val =
          this.parentElement.querySelector(".curr-quantity").innerHTML;
        let nextVal = Number(val);

        if (ctx === "increment") {
          nextVal += 1;
        } else if (ctx === "decrement") {
          nextVal -= 1;
        }

        if (cart) {
          await cart.updateQuantity(idx, nextVal);
        }
      }, 300)
    );
  }
}

customElements.define("update-quantity", UpdateQuantity);

/*
Cart Update
*/

class CartUpdate extends HTMLElement {
  constructor() {
    super();
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  connectedCallback() {
    this.addEventListener(
      "change",
      this.debounce(async (e) => {
        const cart = document.querySelector("site-cart");
        const idx = e.target.dataset.index;
        const val = e.target.value;

        if (cart) {
          await cart.updateQuantity(idx, val);
        }
      }, 300)
    );
  }
}

customElements.define("cart-update", CartUpdate);

/*
Cart Remove
*/

class CartRemove extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", async (e) => {
      e.preventDefault();

      const cart = document.querySelector("site-cart");
      const idx = this.dataset.index;

      if (cart) {
        await cart.updateQuantity(idx, 0);
      }
    });
  }
}

customElements.define("cart-remove", CartRemove);

/*
Site Cart
*/

const CART_BLOCKED_SELLING_PLANS = [4549935290];

class SiteCart extends HTMLElement {
  constructor() {
    super();
    this.cart = null;
    this.isCustomer = this.dataset.isCustomer;
  }

  connectedCallback() {
    this.cart = document.querySelector(".site-cart");
    this.checkUrlForCartOpen();
    this.bindSubscriptionUpgrade();
    this.removeBlockedSellingPlans();

    if (!this._pageshowBound) {
      this._pageshowBound = true;
      window.addEventListener("pageshow", (event) => {
        if (event.persisted) {
          this.removeBlockedSellingPlans();
        }
      });
    }
  }

  async removeBlockedSellingPlans() {
    try {
      const res = await fetch("/cart.js");
      if (!res.ok) return;

      const cart = await res.json();
      if (!cart.items?.length) return;

      const blocked = cart.items.filter((item) => {
        const planId = item.selling_plan_allocation?.selling_plan?.id;
        return planId && CART_BLOCKED_SELLING_PLANS.includes(planId);
      });

      if (!blocked.length) return;

      await Promise.all(
        blocked.map((item) =>
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          })
        )
      );

      window.location.reload();
    } catch (e) {}
  }

  async enforceCartPolicy() {
    if (this._enforcingPolicy) return;
    this._enforcingPolicy = true;

    try {
      const res = await fetch("/cart.js");
      if (!res.ok) return;

      const cart = await res.json();
      if (!cart.items?.length) return;

      const blocked = cart.items.filter((item) => {
        const planId = item.selling_plan_allocation?.selling_plan?.id;
        return planId && CART_BLOCKED_SELLING_PLANS.includes(planId);
      });

      if (!blocked.length) return;

      await Promise.all(
        blocked.map((item) =>
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          })
        )
      );

      const sectionIds = this.getCartSections().map((s) => s.section).join(",");
      const sectionsRes = await fetch(`/?sections=${sectionIds}`);
      if (!sectionsRes.ok) return;

      const data = await sectionsRes.json();
      this.renderCartSections(data);
    } catch (e) {}

    this._enforcingPolicy = false;
  }

  bindSubscriptionUpgrade() {
    const cartItemsContainer = document.querySelector(".js-cart-items");
    if (!cartItemsContainer) return;

    cartItemsContainer.addEventListener("click", (e) => {
      const btn = e.target.closest(".upgrade-to-sub-js");
      if (btn) {
        const select = btn.parentElement.querySelector(".selling-plan-select");
        if (select) {
          select.focus();
          select.click();
        }
      }
    });

    cartItemsContainer.addEventListener("change", async (e) => {
      if (!e.target.classList.contains("selling-plan-select")) return;
      const planId = e.target.value;
      if (!planId) return;

      const cartItem = e.target.closest(".cart-item");
      if (!cartItem) return;

      const variantId = cartItem.dataset.variantId;
      const cartIndex = parseInt(cartItem.dataset.cartIndex, 10);
      const qtyEl = cartItem.querySelector(".quantity-js");
      const quantity = qtyEl ? parseInt(qtyEl.textContent.trim(), 10) : 1;

      const loader = cartItem.querySelector(".cart-loader");
      const price = cartItem.querySelector(".cart-price");
      if (price) price.classList.add("opacity-0");
      if (loader) loader.classList.remove("opacity-0");

      await fetch("/cart/change", this.buildConfig(JSON.stringify({
        line: cartIndex,
        quantity: 0,
      })));

      await this.addVariantToCart(variantId, quantity, parseInt(planId, 10), false);
    });
  }

  checkUrlForCartOpen() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("cart_open") === "true") {
      this.openCart();
    }
  }

  openCart() {
    if (this.cart) {
      this.cart.classList.add("active");
    }
  }

  closeCart() {
    if (this.cart) {
      this.cart.classList.remove("active");
    }
  }

  toggleCart() {
    if (this.cart.classList.contains("active")) {
      this.closeCart();
    } else {
      this.openCart();
    }
  }

  getCartSections() {
    return [
      {
        section: "main-cart-items",
        selector: "#main-cart-items",
      },
      {
        section: "main-cart-footer",
        selector: "#main-cart-footer",
      },
      {
        section: "main-cart-header",
        selector: "#main-cart-header",
      },
      {
        section: "header",
        selector: "#header",
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  renderCartSections(sections) {
    const knownSections = this.getCartSections();

    Object.keys(sections).forEach((sectionKey) => {
      const config = knownSections.find((s) => s.section === sectionKey);
      if (!config) return;
      const el = document.querySelector(config.selector);
      if (!el) return;
      el.innerHTML = this.getSectionInnerHTML(sections[sectionKey], config.selector);
    });

    this.enforceCartPolicy();
  }

  buildConfig(body) {
    return {
      body: body,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
    };
  }

  addVariantToCart(id, quantity = 1, sellingPlan, openCart = true) {

    if (sellingPlan && CART_BLOCKED_SELLING_PLANS.includes(Number(sellingPlan))) {
      return Promise.resolve(null);
    }

    if (openCart) {
      this.openCart();
    }

    const items = [
      sellingPlan
        ? { id, quantity, selling_plan: sellingPlan }
        : { id, quantity },
    ];
    const sections = this.getCartSections().map((s) => s.section);
    const body = JSON.stringify({ items, sections });
    const config = this.buildConfig(body);

    return fetch(`/cart/add`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }
        this.renderCartSections(response.sections);

        return response;
      })
      .catch((e) => {
        // handle error
      });
  }

  addVariantToCartWithSubscription(variantId, quantity = 1, planId, openCart) {
    const sellingPlanId = planId;
    return this.addVariantToCart(variantId, quantity, sellingPlanId, openCart);
  }

  getCart() {
    return fetch("/cart.js").then((response) => response.json());
  }

  updateQuantity(line, quantity) {
    const items = Array.from(document.querySelectorAll(".cart-item"));
    const sections = this.getCartSections().map((s) => s.section);
    const body = JSON.stringify({ line, quantity, sections });
    const config = this.buildConfig(body);
    const item = items[line - 1];
    const price = item.querySelector(".cart-price");
    const loader = item.querySelector(".cart-loader");

    if (price) {
      price.classList.add("opacity-0");
    }
    if (loader) {
      loader.classList.remove("opacity-0");
    }

    return fetch("/cart/change", config)
      .then((response) => response.json())
      .then(async (response) => {
        this.renderCartSections(response.sections);
        this.updateMemberVisibility();
        await this.removeMemberProductsIfNoBundleOrCustomer();

        if (price) {
          price.classList.remove("opacity-0");
        }
        if (loader) {
          loader.classList.add("opacity-0");
        }
      })
      .catch(() => {
        // handle error
      });
  }
}

customElements.define("site-cart", SiteCart);

/*
Numin Global Utilities
*/

window.numin = window.numin || {};

window.numin.addTrialToCheckout = function (variantId, sellingPlanId) {
  return fetch("/cart/clear.js", { method: "POST" })
    .then(function () {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1, selling_plan: sellingPlanId }),
      });
    })
    .then(function () { window.location.href = "/checkout"; })
    .catch(function () { window.location.href = "/checkout"; });
};

/*
Mobile Menu
*/

class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.wrapper = null;
    this.trigger = null;
    this.isOpen = false;
  }

  connectedCallback() {
    this.wrapper = this.querySelector(".mobile-menu");
    this.trigger = document.querySelector(".burger-menu-js");

    this.trigger.addEventListener("click", () => {
      this.isOpen ? this.close() : this.open();
    });
  }

  open() {
    var headerEl = document.getElementById("site-header");

    // Force header to solid white so burger X and logo are visible
    headerEl.classList.remove("bg-transparent", "text-white");
    headerEl.classList.add("bg-white", "text-blue-main");
    var cta = headerEl.querySelector("[data-header-cta]");
    if (cta) {
      cta.classList.remove("text-white");
      cta.classList.add("text-blue-main");
    }

    // Position menu below header bar
    var rect = headerEl.getBoundingClientRect();
    this.wrapper.style.top = rect.bottom + "px";

    // Add extra bottom padding to cover announcement bar gap when it scrolls away
    var announcement = document.getElementById("shopify-section-announcement");
    var announcementH = announcement ? announcement.offsetHeight : 0;
    this.wrapper.style.paddingBottom = (64 + announcementH) + "px";

    this.wrapper.classList.remove("hidden");

    // Toggle burger → X
    this.trigger.classList.add("is-open");

    document.body.style.overflow = "hidden";
    this.isOpen = true;
  }

  close() {
    this.wrapper.classList.add("hidden");

    // Toggle X → burger
    this.trigger.classList.remove("is-open");

    document.body.style.overflow = "";
    this.isOpen = false;

    // Let ScrollAwareHeader restore correct header colors based on scroll position
    window.dispatchEvent(new Event("scroll"));
  }
}

customElements.define("mobile-menu", MobileMenu);

/*
Site Video
*/

class SiteVideo extends HTMLElement {
  connectedCallback() {
    const showVideoOverlay = this.dataset.showVideoOverlay === "true";

    this.playBtn = this.querySelector(".play-button-js");
    this.video = this.querySelector("video");

    if (this.playBtn) {
      this.playBtn.addEventListener("click", () => {
        this.pauseOtherVideos();
        if (this.video.paused) {
          this.video.muted = false; // Unmute when playing
          this.video.play();
        } else {
          this.video.pause();
        }
      });

      this.video.addEventListener("click", () => {
        this.pauseOtherVideos();
        if (this.video.paused) {
          this.video.muted = false; // Unmute when playing
          this.video.play();
        } else {
          this.video.pause();
        }
      });

      if (!showVideoOverlay) {
        this.video.addEventListener("ended", () => {
          this.playBtn.classList.remove("hidden");
        });

        this.video.addEventListener("pause", () => {
          this.playBtn.classList.remove("hidden");
        });

        this.video.addEventListener("play", () => {
          this.playBtn.classList.add("hidden");
        });
      }
    }

    if (this.dataset.stopOnObserve === "true") {
      this.stopOnObserve();
    } else {
      this.loadOnObserve();
    }
  }

  pauseOtherVideos() {
    document.querySelectorAll("site-video").forEach((videoComponent) => {
      const video = videoComponent.querySelector("video");
      if (video !== this.video && !video.paused) {
        video.pause();
      }
    });
  }

  stopOnObserve() {
    if ("IntersectionObserver" in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (!entry.isIntersecting) {
            video.pause();
          }
        });
      });

      videoObserver.observe(this.querySelector("video"));
    }
  }

  loadOnObserve() {
    if ("IntersectionObserver" in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            if (video.readyState !== 4) {
              [].slice
                .call(video.querySelectorAll("source"))
                .forEach((source) => {
                  if (source.dataset.src) {
                    source.src = source.dataset.src;
                  }
                });
              video.load();
            }
          }
        });
      });

      videoObserver.observe(this.querySelector("video"));
    }
  }
}

customElements.define("site-video", SiteVideo);

/*
Klaviyo Signup
*/

class KlaviyoSignup extends HTMLElement {
  constructor() {
    super();
    this.context = this.dataset.context;
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    if (this.form) {
      this.form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.submitForm(e);
      });
    }
  }

  async submitForm(e) {
    const error = this.querySelector(".error");
    const success = this.querySelector(".success");
    const emailOrPhone = this.form.querySelector('[type="text"]');
    const consent = this.form.querySelector('[type="checkbox"]');
    const submit = this.form.querySelector('[type="submit"]');
    const listId = this.dataset.listId;

    const fmtEmailOrPhone = emailOrPhone.value
      .replace("(", "")
      .replace(")", "")
      .replace("-", "")
      .replace(" ", "");
    const isAllNumbers = (str) => /^\d+$/.test(str);
    const isPhone = isAllNumbers(fmtEmailOrPhone);
    if (isPhone && !consent.checked == true) {
      error.innerHTML = "Please opt in to SMS to continue.";
      return;
    }

    error.innerHTML = "";

    const submitText = submit.innerHTML;
    const submitWidth = submit.getBoundingClientRect().width;
    submit.style.width = `${submitWidth}px`;
    submit.innerHTML = "...";

    const payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: emailOrPhone.value,
                subscriptions: {
                  email: { marketing: { consent: "SUBSCRIBED" } },
                },
              },
            },
          },
        },
        ...(listId && {
          relationships: { list: { data: { type: "list", id: listId } } },
        }),
      },
    };

    try {
      const resp = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=W5LSge`,
        {
          method: "POST",
          headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json",
            revision: "2025-01-15",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!resp.ok) {
        const errorData = await resp.json();
        throw new Error(
          errorData.errors?.[0]?.detail || "Klaviyo subscription request failed"
        );
      }

      this.form.reset();
      submit.innerHTML = submitText;
      success.classList.remove("hidden");
      emailOrPhone.blur();
    } catch (e) {
      error.classList.remove("hidden");
      error.innerHTML =
        e.message || "Oops, there was an error. Please try again.";
      submit.innerHTML = submitText;
    }
  }
}

customElements.define("klaviyo-signup", KlaviyoSignup);

/*
Product Quantity Selector
*/

class ProductQuantitySelector extends HTMLElement {
  connectedCallback() {
    this.quantityResult = this.querySelector(".quantity-js");
    const quantityMinus = this.querySelector(".quantity-minus-js");
    const quantityPlus = this.querySelector(".quantity-plus-js");

    quantityMinus.addEventListener("click", () => {
      if (parseInt(this.quantityResult.textContent) > 1) {
        this.quantityResult.textContent =
          parseInt(this.quantityResult.textContent) - 1;
      }

      const quant = this.querySelector('[name="quantity"]');
      if (quant) {
        quant.value = parseInt(this.quantityResult.textContent);
      }
    });

    quantityPlus.addEventListener("click", () => {
      this.quantityResult.textContent =
        parseInt(this.quantityResult.textContent) + 1;

      const quant = this.querySelector('[name="quantity"]');
      if (quant) {
        quant.value = parseInt(this.quantityResult.textContent);
      }
    });
  }
}

customElements.define("product-quantity-selector", ProductQuantitySelector);

/*
Accordion Item
*/

class AccordionItem extends HTMLElement {
  connectedCallback() {
    this.isFullRotation = this.dataset.fullRotation === "true";
    this.summaryOnly = this.dataset.summaryOnly === "true";
    this.startOpen = this.dataset.startOpen === "true";

    this.icon = this.querySelector("svg");
    this.details = this.querySelector("details");
    this.content = this.querySelector(".content");
    this.summary = this.querySelector("summary");

    this.content.style.transition = "none";

    if (this.startOpen) {
      this.details.open = true;
      this.content.style.maxHeight = this.content.scrollHeight + "px";
      this.icon.style.transform = "rotate(180deg)";
    } else {
      this.content.style.maxHeight = "0px";
    }

    requestAnimationFrame(() => {
      this.content.style.transition = "max-height 0.3s ease";
    });

    const target = this.summaryOnly ? this.summary : this.details;
    target.addEventListener("click", (e) => {
      e.preventDefault();
      this.animateHeight();
    });
  }

  animateHeight() {
    const isOpen = this.details.open;

    if (isOpen) {
      if (this.isFullRotation) {
        this.icon.style.transform = "rotate(45deg)";
      } else {
        this.icon.style.transform = "rotate(0deg)";
      }
      this.content.style.maxHeight = "0px";
      setTimeout(() => {
        this.details.open = false;
      }, 300);
    } else {
      this.details.open = true;
      this.icon.style.transform = "rotate(180deg)";
      this.content.style.maxHeight = this.content.scrollHeight + "px";
    }
  }
}

customElements.define("accordion-item", AccordionItem);

/*
Site Modal
*/

class SiteModal extends HTMLElement {
  connectedCallback() {
    this.registerEvents();
    this.defineAutoOpenRoutine();
    this.modal = this.querySelector(".modal");
  }

  openModal() {
    if (this.modal) {
      document.body.classList.add("overflow-hidden");
      this.modal.classList.add("active");
    }
  }

  closeModal() {
    if (this.modal) {
      document.body.classList.remove("overflow-hidden");
      this.modal.classList.remove("active");
    }
  }

  registerEvents() {
    const opens = this.querySelectorAll(".modal-open");
    const closes = this.querySelectorAll(".modal-close");
    const triggerClass = this.dataset.trigger;
    const triggers = document.querySelectorAll(triggerClass);

    if (triggers) {
      triggers.forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
          const agreeError = document.querySelector(".agree-error");
          if (agreeError) {
            agreeError.classList.add("hidden");

            if (e.target.classList.contains("select-subscription")) {
              if (!document.getElementById("agreeWithSubscription").checked) {
                agreeError.classList.remove("hidden");
                return;
              }
            }
          }

          this.openModal();
        });
      });
    }

    Array.from(opens).forEach((open) => {
      open.addEventListener("click", (e) => {
        this.openModal();
      });
    });

    Array.from(closes).forEach((close) => {
      close.addEventListener("click", (e) => {
        this.closeModal();
      });
    });
  }

  defineAutoOpenRoutine() {
    const autoOpenTimeout = this.dataset.autoOpenTimeout;
    if (
      autoOpenTimeout &&
      !localStorage.getItem("feno-subscribe") &&
      !sessionStorage.getItem("feno-subscribe")
    ) {
      setTimeout(() => {
        this.openModal();
      }, autoOpenTimeout);
    }
  }
}

customElements.define("site-modal", SiteModal);

/*
Tabs Content
*/

class TabsContent extends HTMLElement {
  connectedCallback() {
    const tabButtons = this.querySelectorAll("#tabs button");
    const contentBlocks = this.querySelectorAll("#contents > div");

    tabButtons.forEach((button, buttonIndex) => {
      button.addEventListener("click", () => {
        tabButtons.forEach((btn) => {
          btn.classList.remove("border-b-2", "border-white");
          btn.classList.add("opacity-40");
        });
        button.classList.add("border-b-2", "border-white");
        button.classList.remove("opacity-40");

        contentBlocks.forEach((content, contentIndex) => {
          if (buttonIndex === contentIndex) {
            content.classList.remove("absolute", "invisible", "opacity-0");
          } else {
            content.classList.add("absolute", "invisible", "opacity-0");
          }
        });
      });
    });
  }
}

customElements.define("tabs-content", TabsContent);

/*
Fifty Fifty Video
*/

class FiftyFiftyVideo extends HTMLElement {
  connectedCallback() {
    const veil = this.querySelector(".video-veil");
    const video = this.querySelector("video");

    this.addEventListener("click", (e) => {
      const playBtn = e.target.closest(".play-video");
      if (playBtn) {
        if (video.paused) {
          veil && veil.classList.add("opacity-0");
          video.play();
        } else {
          veil && veil.classList.remove("opacity-0");
          video.pause();
        }
      }
    });
  }
}

customElements.define("fifty-fifty-video", FiftyFiftyVideo);

/*
See More
*/

class SeeMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const button = this.querySelector(".button-see-more");
    const items = this.querySelectorAll(".see-more-item");

    if (!button || items.length === 0) return;

    button.addEventListener("click", () => {
      items.forEach((item) => {
        item.style.display = "block";
      });
      button.style.display = "none";
    });
  }
}

customElements.define("see-more", SeeMore);

/*
Video Sound Toggle
*/

class VideoSoundToggle extends HTMLElement {
  connectedCallback() {
    const video = this.querySelector(".heroVideo");
    const muteBtn = this.querySelector("#muteToggle");
    const iconMuted = this.querySelector("#icon-muted");
    const iconUnmuted = this.querySelector("#icon-unmuted");

    document.addEventListener("click", (e) => {
      if (muteBtn.contains(e.target)) {
        video.muted = !video.muted;
        iconMuted.classList.toggle("hidden", !video.muted);
        iconUnmuted.classList.toggle("hidden", video.muted);
      }
    });
  }
}

customElements.define("video-sound-toggle", VideoSoundToggle);

/*
Header Menu
*/

class HeaderMenu extends HTMLElement {
  connectedCallback() {
    const header = document.querySelector(".site-header");
    const input = header.querySelector(".search-input");

    this._handleClick = (e) => {
      const button = e.target.closest("button");

      if (button && button.matches(".toggle-search")) {
        header.classList.toggle("active");
        setTimeout(() => {
          header.classList.contains("active") ? input.focus() : input.blur();
        }, 100);
      }

      if (button && button.matches(".mobile-menu-toggle")) {
        const mobileMenu = document.querySelector(".mobile-menu");
        const menuIcons = button.querySelectorAll("svg");
        const isOpen = mobileMenu.classList.contains("opacity-100");

        document.body.classList.toggle("overflow-hidden", !isOpen);

        mobileMenu.classList.toggle("opacity-100");
        mobileMenu.classList.toggle("visible");
        mobileMenu.classList.toggle("opacity-0");
        mobileMenu.classList.toggle("invisible");

        menuIcons[0].classList.toggle("hidden");
        menuIcons[1].classList.toggle("hidden");
      }

      const link = e.target.closest("a");
      if (link && document.querySelector(".mobile-menu.opacity-100")) {
        const mobileMenu = document.querySelector(".mobile-menu");
        const toggleButton = document.querySelector(".mobile-menu-toggle");
        const menuIcons = toggleButton.querySelectorAll("svg");

        document.body.classList.remove("overflow-hidden");
        mobileMenu.classList.remove("opacity-100", "visible");
        mobileMenu.classList.add("opacity-0", "invisible");

        menuIcons[0].classList.remove("hidden");
        menuIcons[1].classList.add("hidden");
      }
    };

    this._handleKeydown = (e) => {
      if (e.key === "Escape") {
        header.classList.remove("active");
        setTimeout(() => input.blur(), 100);
      }
    };

    document.addEventListener("click", this._handleClick);
    document.addEventListener("keydown", this._handleKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this._handleClick);
    document.removeEventListener("keydown", this._handleKeydown);
  }
}

customElements.define("header-menu", HeaderMenu);

/*
ScrollAwareHeader
*/

class ScrollAwareHeader extends HTMLElement {
  constructor() {
    super();
    this.targetId = this.getAttribute("target-id") || "site-header";
    this.minWidth = parseInt(this.getAttribute("min-width") || "1024", 10);

    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    document.addEventListener("DOMContentLoaded", () => this.init());
  }

  init() {
    const header = document.getElementById(this.targetId);
    const isTransparent = this.hasAttribute("data-transparent");
    const isOverlap = this.hasAttribute("data-overlap");

    // Set header offset CSS variable for overlay pages
    if (isTransparent || isOverlap) {
      this.setHeaderOffset();
    }

    if (!header || (!isTransparent && !isOverlap)) return;

    this.header = header;
    this.cta = header.querySelector("[data-header-cta]");
    this.isTransparent = isTransparent;

    // Scroll threshold = announcement bar height
    var announcement = document.getElementById("shopify-section-announcement");
    this.scrollThreshold = announcement ? announcement.offsetHeight : 0;

    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  }

  setHeaderOffset() {
    var announcement = document.getElementById("shopify-section-announcement");
    var headerSection = document.getElementById("shopify-section-header");
    var offset = 0;
    if (announcement) offset += announcement.offsetHeight;
    if (headerSection) offset += headerSection.offsetHeight;
    document.documentElement.style.setProperty("--header-offset", offset + "px");
  }

  handleScroll() {
    if (window.scrollY > this.scrollThreshold) {
      this.header.classList.remove("bg-transparent");
      this.header.classList.add("bg-white");
      if (this.isTransparent) {
        this.header.classList.remove("text-white");
        this.header.classList.add("text-blue-main");
        if (this.cta) {
          this.cta.classList.remove("text-white");
          this.cta.classList.add("text-blue-main");
        }
      }
    } else {
      this.header.classList.remove("bg-white");
      this.header.classList.add("bg-transparent");
      if (this.isTransparent) {
        this.header.classList.remove("text-blue-main");
        this.header.classList.add("text-white");
        if (this.cta) {
          this.cta.classList.remove("text-blue-main");
          this.cta.classList.add("text-white");
        }
      }
    }
  }
}

customElements.define("scroll-aware-header", ScrollAwareHeader);

/*
CustomMarquee
*/

class CustomMarquee extends HTMLElement {
  constructor() {
    super();
    this._paused = false;
    this._rafIds = new Map();
    this._offsets = new Map();
    this._lastTimestamps = new Map();
    this._resizeObserver = null;
  }

  connectedCallback() {
    this._tracks = Array.from(this.querySelectorAll(".element-track"));
    if (!this._tracks.length) return;

    this._originalChildren = new Map();
    this._tracks.forEach((track) => {
      this._originalChildren.set(track, Array.from(track.children));
    });

    this._setupAll();

    this._resizeObserver = new ResizeObserver(() => this._setupAll());
    this._resizeObserver.observe(this);
  }

  disconnectedCallback() {
    for (const id of this._rafIds.values()) cancelAnimationFrame(id);
    this._rafIds.clear();
    this._offsets.clear();
    this._lastTimestamps.clear();

    this.removeEventListener("mouseenter", this._onEnter);
    this.removeEventListener("mouseleave", this._onLeave);
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }
  }

  _setupAll() {
    const duration = parseFloat(this.getAttribute("duration")) || 35;
    const containerWidth = this.clientWidth || 0;

    this._tracks.forEach((track) => {
      const prevId = this._rafIds.get(track);
      if (prevId) {
        cancelAnimationFrame(prevId);
        this._rafIds.delete(track);
      }
      this._lastTimestamps.delete(track);
      this._offsets.set(track, 0);

      const originalChildren = this._originalChildren.get(track) || [];
      track.innerHTML = "";
      if (!originalChildren.length) return;

      originalChildren.forEach((child) =>
        track.appendChild(child.cloneNode(true))
      );

      let safety = 0;
      const MAX_CLONE_BATCHES = 100;
      let prevWidth = track.scrollWidth;

      while (track.scrollWidth < containerWidth && safety < MAX_CLONE_BATCHES) {
        originalChildren.forEach((child) =>
          track.appendChild(child.cloneNode(true))
        );
        safety += 1;

        const newWidth = track.scrollWidth;
        if (newWidth <= prevWidth) break;
        prevWidth = newWidth;
      }

      const totalDistance = track.scrollWidth > 0 ? track.scrollWidth + 12 : 0;
      if (totalDistance === 0 || duration <= 0) return;

      const speed = totalDistance / duration;

      const animate = (ts) => {
        const id = requestAnimationFrame(animate);
        this._rafIds.set(track, id);

        if (this._paused) return;

        const last = this._lastTimestamps.get(track) || ts;
        const delta = (ts - last) / 1000;
        this._lastTimestamps.set(track, ts);

        let offset = this._offsets.get(track) || 0;
        offset += delta * speed;
        if (offset >= totalDistance) offset -= totalDistance;
        this._offsets.set(track, offset);

        track.style.transform = `translateX(${-offset}px)`;
        track.style.willChange = "transform";
      };

      const id = requestAnimationFrame(animate);
      this._rafIds.set(track, id);
    });
  }
}

customElements.define("custom-marquee", CustomMarquee);

/*
Sticky Fifty (sticky image, scrollable content)
*/

class StickyFifty extends HTMLElement {
  connectedCallback() {
    const mediaWrap = this.querySelector("[data-sticky-media]");
    const contentStage = this.querySelector("[data-content-stage]");
    const stepsWrap =
      this.querySelector("[data-steps]") ||
      document.querySelector("[data-steps]");
    if (!mediaWrap || !contentStage || !stepsWrap) return;

    this.mediaImgs = Array.from(
      mediaWrap.querySelectorAll("img[data-media-index]")
    );
    this.contentItems = Array.from(
      contentStage.querySelectorAll(".content-item")
    );
    this.steps = Array.from(stepsWrap.querySelectorAll(".step"));
    if (
      !this.mediaImgs.length ||
      !this.contentItems.length ||
      !this.steps.length
    )
      return;

    this.vh = window.innerHeight;
    this.activeIndex = 0;
    this.riseDistance = 200; // px content rises from bottom of card
    this.maxBlur = 20; // px maximum blur while approaching

    this.contentItems.forEach((el) => {
      el.style.willChange = "transform, opacity, filter";
      el.style.transition =
        "opacity 300ms linear, transform 300ms linear, filter 300ms linear";
      el.style.pointerEvents = "none";
      el.style.visibility = "hidden";
    });

    this.setActive(0);

    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);

    window.addEventListener("scroll", this.handleScroll, { passive: true });
    window.addEventListener("resize", this.handleResize);

    this.handleScroll();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    this.vh = window.innerHeight;
    this.handleScroll();
  }

  setActive(idx) {
    if (idx === this.activeIndex) return;
    this.activeIndex = idx;
    this.mediaImgs.forEach((img) => {
      const i = parseInt(img.dataset.mediaIndex);
      img.style.opacity = i === idx ? "1" : "0";
    });
  }

  handleScroll() {
    const centerY = this.vh / 2;

    let closestIdx = 0;
    let closestDist = Infinity;
    this.steps.forEach((step, i) => {
      const r = step.getBoundingClientRect();
      const stepCenter = r.top + r.height / 2;
      const dist = Math.abs(stepCenter - centerY);
      if (dist < closestDist) {
        closestDist = dist;
        closestIdx = i;
      }
    });

    const nextIdx = Math.min(closestIdx + 1, this.contentItems.length - 1);
    this.setActive(closestIdx);

    const rn = this.steps[nextIdx].getBoundingClientRect();
    const nextCenter = rn.top + rn.height / 2;
    const fromBottom = nextCenter - centerY;
    const p = Math.max(0, Math.min(1, 1 - fromBottom / (this.vh * 0.6)));

    this.contentItems.forEach((el, i) => {
      if (i === closestIdx) {
        el.style.opacity = "1";
        el.style.transform = "translateY(0px)";
        el.style.filter = "blur(0px)";
        el.style.visibility = "visible";
        el.style.zIndex = "2";
      } else if (i === nextIdx) {
        const translate = Math.round(this.riseDistance * (1 - p));
        const blur = (this.maxBlur * (1 - p)).toFixed(2);
        const opacity = (0.2 + 0.8 * p).toFixed(3);
        el.style.opacity = opacity;
        el.style.transform = `translateY(${translate}px)`;
        el.style.filter = `blur(${blur}px)`;
        el.style.visibility = "visible";
        el.style.zIndex = "1";
      } else {
        el.style.opacity = "0";
        el.style.transform = "translateY(10px)";
        el.style.filter = "blur(0px)";
        el.style.visibility = "hidden";
        el.style.zIndex = "0";
      }
    });
  }
}

if (!customElements.get("sticky-fifty")) {
  customElements.define("sticky-fifty", StickyFifty);
}
